import View     from '@widesk-ui/components/View';
import React    from 'react';

/**
 * Titre de modale précédé d'une icône.
 *
 * Une modale s'ouvre par-dessus ce qu'on regardait : l'icône dit de quoi il s'agit avant même que le
 * titre soit lu, et elle reprend celle du bouton d'où l'on vient, pour que le lien entre les deux
 * soit immédiat.
 */
export default function ModalTitle(props: { icon: React.ReactNode; children: React.ReactNode; }) {
	return (
		<View row centerV gap="sm">
			{props.icon}

			<View flex>{props.children}</View>
		</View>
	);
}
